import { render } from "./Tariff.vue?vue&type=template&id=353397db&scoped=true"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"

import "./Tariff.vue?vue&type=style&index=0&id=353397db&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353397db"]])

export default __exports__